import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiError } from "src/api/axiosClient/types";
import { RootState } from "src/store";
import { MediaInfo, GetAssetsParams } from "../types";
import { AssetLibraryState } from "./types";

const initialState: AssetLibraryState = {
  loading: {
    getList: false,
    create: false,
    update: false,
    delete: false,
    upload: false,
    loadMore: false,
  },
  filter: {
    companyId: "",
    offset: 0,
    limit: 30,
    page: 0,
  },
  list: null,
  error: null,
};

const assetLibrarySlice = createSlice({
  name: "assetLibrary",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<Record<keyof AssetLibraryState["loading"], boolean>>>) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetAssetsParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: MediaInfo[];
        count: number;
      }>
    ) => {
      state.list = action.payload;
    },
    appendList: (
      state,
      action: PayloadAction<{
        items: MediaInfo[];
        count: number;
      }>
    ) => {
      if (state.list) {
        state.list = {
          items: [...state.list.items, ...action.payload.items],
          count: action.payload.count,
        };
      } else {
        state.list = action.payload;
      }
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: (state) => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: (state) => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const { setLoading, setFilter, setList, appendList, setError, resetList, resetError, resetSlice } = assetLibrarySlice.actions;

export const isAssetLibraryLoading = (state: RootState) => state.assetLibrary?.loading;
export const getAssets = (state: RootState) => state.assetLibrary?.list;
export const getAssetLibraryFilter = (state: RootState) => state.assetLibrary?.filter;
export const getAssetLibraryError = (state: RootState) => state.assetLibrary?.error;

export default assetLibrarySlice.reducer; 